export default __webpack_public_path__ + "images/watermark-logo-white@2x.0758906ed33a246b1fad06ed4da18787.png";